import { Target, BookMarked, ShieldCheck, HandHeart } from "lucide-react";
import { Reveal } from "@/components/landing/Reveal";

const CARDS = [
  { icon: Target, title: "Built for formation", body: "We measure success by what happens away from the screen. Engagement matters, and here it serves formation rather than competing with it." },
  { icon: BookMarked, title: "Built on Scripture", body: "The Bible isn't an add-on. It's in every text field, every note, every community post." },
  { icon: ShieldCheck, title: "Safe by design", body: "No ads, no algorithm, no adjacent content that contradicts your values." },
  { icon: HandHeart, title: "Priced for the Kingdom", body: "The dorm room Bible study and the church plant shouldn't be priced out of good tools. Small ministries start free, and creators keep everything they earn beyond standard payment processing." },
];

export const Differentiators = () => (
  <section className="relative py-16 md:py-24">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <p className="text-sm font-semibold uppercase tracking-[0.2em] text-green-dark mb-4">
          What Makes This Different
        </p>
        <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-ink max-w-2xl text-balance">
          Formation Infrastructure, Not Another Content App.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-5">
        {CARDS.map((c, i) => {
          const Icon = c.icon;
          return (
            <Reveal key={c.title} delay={i * 0.08}>
              <div
                data-testid={`diff-card-${i}`}
                className="group h-full bg-ink text-sage rounded-3xl p-8 md:p-10 hover:bg-green-dark transition-colors duration-500"
              >
                <Icon className="w-7 h-7 text-green mb-6 group-hover:text-sage transition-colors duration-500" strokeWidth={1.75} />
                <h3 className="font-serif text-2xl md:text-3xl mb-3">{c.title}</h3>
                <p className="text-sage/70 leading-relaxed">{c.body}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
